define([
    'base/utils/iamHttpService',
    'base/utils/cookie',
    'base/utils/utility',
    'base/utils/htmlTransformer'
],
function(iamHttpService, cookieOp, util, htmlTransformer, $filter){
    'use strict';
    var timeFormat, me, iamUtils, iamEnv;

    function send2CloudBISafe(){
        try{
            send2CloudBI.apply(null,arguments);
                
        }catch(e){
            console.dir(e)
        }
    }
    var loginVerificationCtrl = function($scope, $sce, i18n, _iamUtils, _iamEnv, $filter, $interval){
        timeFormat = this.timeFormat;
        me = this;
        iamUtils = _iamUtils;
        iamEnv = _iamEnv;
        $scope.model = {
            currentLanguage: window.language,
            tipPosition:'top',
            tipWidth: '250px',
            msgCodeWidth: '100px',
            inputFieldHeight: iamUtils.layout.inputFieldHeight,
            changeMobileHref:getChangeMobileHref(),
            msgTxtId:'msgTxtId',
            msgBtnTxt: i18n('msgCodeTxt'),//loginVerification.emailCodeTxt
            lockInfo: '', 
            presetInfo:'',
            lastSuccessTime:'',
            failedTimes:'',
            lastFailedTime:'',
            phoneNum:'',
            actionError:'',
            isSendSmsCodeFailed :false,
            keypress: function (event) {
                if(event.keyCode===13){
                    $('#OKBtn').click();
                }
            },
            verificationType: '' // phone,email,mfa 
        };


        $scope.i18n = i18n;
        $scope.onGetMsgBtnClick = function(){
            onGetMsgBtnClick($scope, i18n, iamUtils);
        };
        $scope.onOkBtnClick = function(){
            onOkBtnClick($scope, iamUtils, iamEnv);
        };
        $scope.onCancelBtnClick = function(){
            send2CloudBISafe('button', 'click' , 'login_verification_' + $scope.model.verificationType + '_cancel' , '');
            var service = util.getUrlParams().service;
            const hwIdLogoutLink = {value: 'https://id1.cloud.huawei.com/AMW/logout'};
            var redirectUrl = hwIdLogoutLink.value;
            service !== undefined ? service = 'https://auth.huaweicloud.com/authui/logout?service=' + service : service = 'https://auth.huaweicloud.com/authui/logout';
            if (redirectUrl) {
                window.location.href = redirectUrl + '?service=' + service;
            } else {
                window.location.href = service;
            }
                
            $('#cancelBtnBtn').removeClass('cancelBtnCls');
            $('#cancelBtnBtn').addClass('disabledCancelBtnCls');
        };

        $scope.model.msgValidator = iamUtils.validator.smsMsgCode();
        $scope.model.emailValidator = iamUtils.validator.msgCode(); //验证先去一样
        $scope.model.mfaValidator = iamUtils.validator.mfaCode();
        $scope.model.mfaHelp = $scope.mfaHelp;
            
        $scope.model.changePhone = function (){
            send2CloudBISafe('button', 'click' , 'login_verification_' + $scope.model.verificationType + '_changePhone' , '');
        };

        $scope.model.buttonEvent = function(name){
            send2CloudBISafe('button', 'click' , 'login_verification_' + $scope.model.verificationType + '_' + name , '');
        }

        $scope.model.msgCodeBlur = function (){

            send2CloudBISafe('input', 'change' , 'login_verification_' + $scope.model.verificationType , $('#' + $scope.model.msgTxtId).widget().getValue());
        };

        document.title = i18n('titles.loginVerification');
        initPageInfo($scope, $sce, i18n, $filter);
    };

    function onGetMsgBtnClick($scope, i18n, iamUtils){
            
        if($scope.model.verificationType){
            send2CloudBISafe('button', 'click' , 'login_verification_' + $scope.model.verificationType , '');
        }

        if($('#getMsgCodeBtn').hasClass('getMsgCodeBtn'))
        {
            disableGetMsgCodeBtn($scope, i18n, iamUtils);
            if($('#msgErrorTip').text() !== '')
            {
                $('#msgErrorTip').text('');
            }

            iamHttpService.post({
                url: '/authui/sendLoginSms',
                params: {}
            }).then(function(data){
                var retJson = typeof data === 'object' ? data : $.parseJSON(data);
                if (retJson.result === 'success')
                {
                    var remainderCount = retJson.remainderCount;
                    if(remainderCount >= 0) {
                        var content = remainderCount==0? i18n('verifyCode.cantAcquire'):
                            iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), remainderCount);
                        $('#msgErrorTip').text(content);
                    }

                    return;
                }
                else if (retJson.result === 'faster')
                {
                    $('#msgErrorTip').text(i18n('verifyCode.intervalError'));
                }
                else if(retJson.result === 'locked')
                {
                    var lockedMsg = i18n('verifyCode.locked');
                    if (retJson.lockDuration && retJson.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), retJson.lockDuration);
                    }
                    $('#msgErrorTip').text(lockedMsg);
                }
                else if(retJson.result === 'error')
                {
                    $('#msgErrorTip').text(i18n('verifyCode.sendFailed'));
                }

                $scope.model.isSendSmsCodeFailed = true;
            }, function(data){
                if (data.status == 403) {
                    var btnBack2Login = [{
                        key: 'btnwed12',
                        label: i18n('btnTxtOK'),
                        accessKey: '3',
                        focused: true,
                        handler: function (event) {
                            iamUtils.redirect2Login();
                        }
                    }];
                    iamUtils.MESSAGE.ERROR(i18n('sessionExpired'), '', 'popupMsg', btnBack2Login, iamUtils.redirect2Login);
                } else {
                    $('#msgErrorTip').text(i18n('systemException'));
                    $scope.model.isSendSmsCodeFailed = true;
                }
            });
        }
    }

    function onOkBtnClick($scope, iamUtils, iamEnv){

        send2CloudBISafe('button', 'click' , 'login_verification_' + $scope.model.verificationType + '_nextStep' , '');
            
        if(!iamUtils.unifyValid.FormValid($('#getMsgDiv')))
        {
            iamUtils.unifyValid.focusFirst($('#getMsgDiv'));
            return;
        }

        if(me.isDisabledOfOkBtn())
        {
            return;
        }
        else
        {
            me.disableOKBtn();
        }

        if (iamEnv.isPublishEnv()) {
            var temp = document.createElement('form');
            if(window.location.search === ''){
                temp.action = '/authui/validateUser';
            }
            else {
                temp.action = '/authui/validateUser?' + window.location.search.substring(1,window.location.search.length);
            }
            temp.method = 'post';
            temp.style.display = 'none';
            if ($scope.model.verificationType!== '' && $scope.model.verificationType!=='none') {
                var opt = document.createElement('textarea');
                opt.name = 'smsCode';
                opt.value = $('#' + $scope.model.msgTxtId).widget().getValue();
                temp.appendChild(opt);
            }
            // step
            var step = document.createElement('textarea');
            step.name = 'step';
            step.value = 'afterAntiPhishing';
            temp.appendChild(step);
            // IAMCSRF
            var IAMCSRFClient = document.createElement('textarea');
            IAMCSRFClient.name = 'IAMCSRF';
            IAMCSRFClient.value = $('#IAMCSRFClient').text();
            temp.appendChild(IAMCSRFClient);
                
            //isSupport 为true 为新接口
            if($scope.isSupport){
                var isSupport = document.createElement('textarea');
                isSupport.name = 'isSupport';
                isSupport.value = true;
                temp.appendChild(isSupport);
            }

            document.body.appendChild(temp);
            temp.submit();
        } else {
            iamHttpService.post({
                url: '/authui/validateUser',
                params: {}
            }).then(function(data){
                if (data.loginResult === 'success')
                {
                    window.location.href = data.redirectUrl;
                    return;
                }
            }, function(data){
                    
            });
        }
    }

    loginVerificationCtrl.prototype.isDisabledOfOkBtn = function() {
        return !$('#OKBtn').hasClass('submitBtn');
    }

    loginVerificationCtrl.prototype.disableOKBtn = function(){
        $('#OKBtn').removeClass('submitBtn');
        $('#OKBtn').addClass('disabledSubmitBtn');
    }

    function initPageInfo($scope, $sce, i18n, $filter){
        getInfoFromServer($scope, $sce, i18n, $filter);

        var actionErrors = util.getUrlParams().actionErrors;
        if(actionErrors !== undefined )
        {
            var msg = {
                '403': i18n('selfManage.alertTip'),
                '406': i18n('invalidInput'),
                '418': i18n('verifyCode.error'),
                '419': i18n('verifyCode.invalid'),
                '429': i18n('loginVerification.mfaCodeLocked')
            };

            $scope.model.actionError = msg[actionErrors];
        }
    }

    function getInfoFromServer($scope, $sce, i18n, $filter){
        var loginURL = '/authui/login' + window.location.search;

        iamHttpService.get({
            url:'/authui/getAntiPhishingInfo',
            params:{
                isSupport: !!$scope.isSupport
            },
            mask: true
        }).then(function(data){
                
            if(data.result === 'failed'){
                window.location.href = loginURL;
                return;
            }

            if(data.loginTip !== undefined){
                $scope.model.presetInfo = $sce.trustAsHtml(htmlTransformer.htmlDecode(String(data.loginTip)));
            }

            var loginRecord = data.loginRecord;
            if(loginRecord !== undefined){
                $scope.model.failedTimes = loginRecord.failedTimes;

                if(loginRecord.lastSuccessfulTime !== undefined){
                    var utcTime = new Date(loginRecord.lastSuccessfulTime.replace(/-/g,'/'));
                    var localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset()*1000*60);
                    $scope.model.lastSuccessTime = $filter('date')(localTime, i18n('dateFormate')) + ' ' + iamUtils.getCurrentTimeZone();
                }

                if(loginRecord.lastFailedTime !== undefined){
                    var utcTime = new Date(loginRecord.lastFailedTime.replace(/-/g,'/'));
                    var localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset()*1000*60);
                    $scope.model.lastFailedTime = $filter('date')(localTime, i18n('dateFormate')) + ' ' + iamUtils.getCurrentTimeZone();
                }
                    
                $scope.model.lockInfo = util.i18nFormat(i18n('loginVerification.lockInfo'), loginRecord.maxTimesFailLock, loginRecord.releaseLockTime);
            }

            if(data.IAMCSRF !== undefined){
                $scope.model.IAMCSRF = $sce.trustAsHtml(htmlTransformer.htmlEncode(data.IAMCSRF));
            }

            // 兼容旧接口，login_protect_type 不存在时
            if(data.mfa&&data.mfa.login_protect_type){
                $scope.model.verificationType = data.mfa.login_protect_type;
            }

            if(data.mobile){ 
                $scope.model.phoneNum = iamUtils.SecurityMasker.maskMobile(data.mobile);
                $scope.model.phoneNum = $scope.model.phoneNum.replace(/^0*/, '+').replace(/-/, ' ');
                $scope.model.verificationType = $scope.model.verificationType||'sms';
            }

            $scope.model.verificationType == 'email' &&  ($scope.model.msgBtnTxt = i18n('loginVerification.emailCodeTxt'));

            if($scope.model.verificationType == 'vmfa'){
                var content = '<div><p>'+ iamUtils.i18nFormat(i18n('loginVerification.MFANotUseMessage2')) +'</p></div>'
                    
                if(data.isTenant !== 'true'){
                    content = '<div><p>'+ i18n('loginVerification.MFANotUseMessage1') +'</p></div>';
                }

                setTimeout(function () {
                    new tinyWidget.Tip({
                        content: content,
                        element: $('#getMFACodeTip'),
                        position: 'bottom',
                        id: 'input_tip1'
                    });
                })

                if (typeof data.showRememberMFA === 'boolean' && data.showRememberMFA) {
                    $scope.authModel.showrememberMFACheckbox = true;
                }

                setTimeout(
                    ()=>{
                        if ($scope.authModel.rememberMFADisabled) {
                            iamUtils.showTooltip($('#rememberMFACheckbox'), i18n('loginVerification.rememberMFALabel.disabledTip'))
                        }
                    }
                )
            }

            if(data.email){
                $scope.model.emailNum = data.email;
                $scope.model.emailCheckContent = iamUtils.i18nFormat(i18n('loginVerification.emailCheckContent'), $scope.model.emailNum);
            }
                
            if($scope.model.phoneNum !== ''){
                $scope.isShowPhone = true;
            }
            else{
                $('#OKBtn').focus();
            }

            /* 华为云局点新版登录验证页面需要 */
            if (me.productTypeIsHWS) {
                $scope.authModel.haveBindEmail = (data.email && data.email !== '');
                $scope.authModel.haveBindPhone = (data.mobile && data.mobile !== '');
                $scope.authModel.havaBindMFA = (data.mfa && data.mfa.sn && data.mfa.sn !== '');
                $scope.authModel.completeMobile = data.mobile;
                if (data.mobile) {
                    // $scope.authModel.countryValue = iamUtils.getCountryValue($scope.authModel.countryCodeList, data.mobile.split('-')[0]);
                    //按严婷婷建议，修改为不显示国家名
                    var code = data.mobile.split('-')[0];
                    $scope.authModel.countryValue = code.replace(/^0*/, '+');
                }
                if ($scope.model.verificationType == 'none' || $scope.model.verificationType == '') {
                    $scope.authModel.disabledSubmitBtn = false;
                }
            }
            /* END */

            $scope.$apply();
        },function(){
            window.location.href = loginURL;
        });
    }

    function disableGetMsgCodeBtn($scope, i18n, iamUtils){
        $('#getMsgCodeBtn').removeClass('getMsgCodeBtn');
        $('#getMsgCodeBtn').addClass('disabledMsgBtn');
        var timeInterval = 60;
        var counter = 0;
        function timer() {
            if (counter < timeInterval) {
                if($scope.model.isSendSmsCodeFailed)
                {
                    activateSendEmailBtn($scope, i18n);
                    $scope.model.isSendSmsCodeFailed = false;
                    $scope.$apply();
                    return;
                }
                counter++;
                $scope.model.msgBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), timeInterval - counter);
                $scope.$apply();

                setTimeout(timer, 1000);
            }
            else {
                activateSendEmailBtn($scope, i18n);
                $scope.$apply();
            }
        }

        setTimeout(timer, 0);
    }

    function activateSendEmailBtn($scope, i18n){
        $('#getMsgCodeBtn').removeClass('disabledMsgBtn');
        $('#getMsgCodeBtn').addClass('getMsgCodeBtn');
        $scope.model.msgBtnTxt = i18n('msgCodeTxt');
        $scope.model.verificationType == 'email' &&  ($scope.model.msgBtnTxt = i18n('loginVerification.emailCodeTxt'));
    }

    function getChangeMobileHref(){
        var isCurCompany = true;
        var userType = cookieOp.getCookie('accountType');
        if (userType === undefined || userType !== 'company')
        {
            isCurCompany = false;
        }

        var service = util.getUrlParams().service !== undefined ? '&service=' + util.getUrlParams().service : '';
        return '/authui/login.html?locale=' + window.language + '&UserType=' + (isCurCompany ? 'e' : 'p') + service + '#/fphone';
    }

    return loginVerificationCtrl;
});


// WEBPACK FOOTER //
// ./public/base/js/loginverification/controllers/loginVerificationController.js